export default {
  CURRENT_CONVERSATION: (state) => state.currentConversation,
  LAST_ANALYSIS: (state) => state.lastAnalysis,
  AVAILABLE_METRICS: (state) => state.availableMetrics,
};
